import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-invite-existing',
  templateUrl: './invite-existing.component.html',
  styleUrls: ['./invite-existing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Template containing invitation for a business for existing users
 */
export class InviteExistingComponent {}
